var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "165px",
    height: "76.463px",
    viewBox: "0 0 165 76.463",
    enableBackground: "new 0 0 165 76.463",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M119.144,18.128h36.793c4.986,0,9.063-4.077,9.063-9.064 s-4.077-9.063-9.063-9.063H51.405c-4.982,0-9.063,4.077-9.063,9.063s4.077,9.064,9.063,9.064h11.925 c3.969,0,7.211,3.242,7.211,7.211c0,3.965-3.242,7.211-7.211,7.211h-39.58c-4.987,0-9.064,4.077-9.064,9.063 c0,4.987,4.077,9.064,9.064,9.064h108.104c4.986,0,9.063-4.077,9.063-9.064c0-4.986-4.077-9.063-9.063-9.063h-12.711 c-3.978,0-7.22-3.246-7.22-7.211C111.924,21.37,115.166,18.128,119.144,18.128L119.144,18.128z M26.53,18.128H12.591H9.064 C4.077,18.128,0,14.047,0,9.064s4.081-9.063,9.064-9.063H26.53c4.987,0,9.063,4.077,9.063,9.063S31.517,18.128,26.53,18.128z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFCD2B",
    d: "M75.471,76.464c18.806,0,34.13-15.324,34.13-34.13 c0-18.797-15.324-34.129-34.13-34.129c-18.797,0-34.13,15.332-34.13,34.129C41.341,61.14,56.673,76.464,75.471,76.464z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M122.187,37.926l-18.737-32.45c-4.226-7.319-14.947-7.286-19.152,0l-18.74,32.45 c-4.209,7.295,1.129,16.392,9.444,16.392c3.738,0,7.426-1.919,9.477-5.467l9.395-16.267l9.395,16.267 c2.043,3.548,5.729,5.467,9.476,5.467C121.054,54.317,126.396,45.229,122.187,37.926L122.187,37.926z M81.162,46.932 c-1.654,2.87-5.011,4.169-8.112,3.275c-4.441-1.29-6.463-6.401-4.176-10.362c1.96-3.398,6.297-4.561,9.692-2.597 C81.964,39.208,83.122,43.541,81.162,46.932L81.162,46.932z M85.314,39.746c-1.783-5.066-7.005-8.084-12.29-7.096l10.581-18.317 c0.472,1.439,0.137,0.711,8.059,14.422L85.314,39.746z M116.274,49.529c-3.399,1.96-7.732,0.802-9.69-2.598l-18.74-32.45 c-3.572-6.19,3.316-13.232,9.461-9.688c2.299,1.328,1.662,0.583,21.566,35.052C120.822,43.228,119.656,47.577,116.274,49.529 L116.274,49.529z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/google-ads.db7594e57c391a6005cb5d87a9b96fde.svg";
export { ForwardRef as ReactComponent };